import styled from 'styled-components';

export const ListMode = {
    Container: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 100px;
    `,
    CountBox: styled.div`
        display: flex;
        gap: 10px;
        &>div{
            flex:1;
            border: 1px solid #000;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 600;
        }
    `,
    EventButtonBox: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
        gap: 10px;
        button{
            width: 100px;
            font-weight: 700;

            &.delete{
                border: 1px solid red;
                color: red;
            }
        }

        .countBox{
            font-size: 14px;
            font-weight: 700;
        }
    `,
    TableBox: styled.div`
        position: relative;
        overflow: auto;
        width: 100%;
        height: 350px;
        border: 1px solid #e0e0e0;

        & > table{
            table-layout: fixed;
            width: 100%;
            text-align: center;
            overflow-anchor: none;
            font-size: 12px;
            border-spacing: 0;

            & > thead {
                position: sticky;
                top: 0;
                background: #fff;
            }

            & > thead > tr > th{
                border-bottom: 1px solid #e0e0e0;
                padding: 5px;
            }

            & > tbody > tr > td{
                border-bottom: 1px solid #e0e0e0;
                padding: 5px;
            }
        }

    `,
    ItemBox: styled.div`
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        .productName{
            display: flex;
            font-weight: 700;
            font-size: 12px;
            justify-content: space-between;

            & > .ctns{
                font-weight: 900;
                color:green;
            }
        }
        .detailInfo{
            font-weight: 500;
            font-size: 8px;

        }
        &.isSelected{
            background: #0000ff20;
        }
    `,
    FooterBox: styled.div`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        gap: 10px;
        padding: 10px;

        button{

            &.refresh{
                color: #000;
                border: none;
                background: #efefef;
            }
        }
    `,
}

export const EditModeModal = {
    HeaderContainer: styled.div`
        padding: 20px 20px 0 20px;
    `,
    BodyContainer: styled.div`
        padding: 20px;
    `,
    TableBox: styled.div`
        position: relative;
        overflow: auto;
        width: 100%;
        height: 300px;
        border: 1px solid #e0e0e0;

        & > table{
            table-layout: fixed;
            width: 100%;
            text-align: center;
            overflow-anchor: none;
            font-size: 12px;
            border-spacing: 0;

            & > thead {
                position: sticky;
                top: 0;
                background: #fff;
            }

            & > thead > tr > th{
                border-bottom: 1px solid #e0e0e0;
                padding: 5px;
            }

            & > tbody > tr > td{
                border-bottom: 1px solid #e0e0e0;
                padding: 5px;
            }
        }
    `,
    FooterBox: styled.div`
        margin-top: 20px;
    `,
}

export const DeleteModeModal = {
    HeaderContainer: styled.div`
        padding: 20px 20px 0 20px;
    `,
    BodyContainer: styled.div`
        padding: 20px;

        .notice{
            text-align: center;
            font-weight: 700;
        }
    `,
    FooterBox: styled.div`
        padding: 20px;

        button{
            border-color: red;
            color: red;
            font-weight: 700;
        }
    `,
}